class CarouselMediaWithText extends HTMLElement {
  constructor() {
    super();

    let section = (this.section = this.dataset.section);
    this.selectors = {
      contentSlider: `.js-content-slider-${section}`,
      mediaSlider: `.js-media-slider-${section}`
    }
    
    this.data = {
      autoplay: 'autoplay',
      autoplaySpeed: 'autoplaySpeed',
      showDots: 'showDots',
      showArrows: 'showArrows'
    }

    this.settings = {
      autoplay: this.dataset[this.data.autoplay] == 'true',
      autoplaySpeed: parseInt(this.dataset[this.data.autoplaySpeed] || 5000),
      showDots: this.dataset[this.data.showDots] == 'true',
      showArrows: this.dataset[this.data.showArrows] == 'true'
    }

    if (
      !this.querySelector(this.selectors.contentSlider) ||
      !this.querySelector(this.selectors.mediaSlider)
    ) return;

    this.init();
    
  }

  init() {
    this.setupContentSlider();
    this.setupMediaSlider();
    this.initSliders();
  }

  setupContentSlider() {
    let settings = {
      init: false,
      loop: true,
      speed: 600,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoHeight: true,
      breakpoints: {
        750: {
          autoHeight: false
        }
      }
    };

    if (this.settings.showDots) {
      Object.assign(settings, {
        pagination: {
          el:'.swiper-pagination',
          clickable: true
        }
      });
    };
    
    this.contentSlider = new Swiper(this.selectors.contentSlider, settings);
    this.contentSlider.on('init', (contentSlider) => {
      contentSlider.controller.control = this.mediaSlider;
    });
    
  }

  setupMediaSlider() { 
    let settings = {
      init: false,
      loop: true,
      speed: 600
    };

    if (this.settings.showArrows) {
      Object.assign(settings, {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
    }

    if (this.settings.autoplay) {
      Object.assign(settings, {
        autoplay: {
          delay: this.settings.autoplaySpeed
        }
      });
    };
    
    this.mediaSlider = new Swiper(this.selectors.mediaSlider, settings);
    this.mediaSlider.on('init', (mediaSlider) => {
      mediaSlider.controller.control = this.contentSlider;
    });
    
  }

  initSliders() {
    this.contentSlider.init();
    this.mediaSlider.init();
    
  }

  
}

customElements.define('carousel-media-with-text', CarouselMediaWithText);